import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const ClientComparisonPageContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: '100%',
  alignItems: "center",
  backgroundColor: theme.palette.jigsaw.white,
}));